import React from 'react';
import { Grid, MenuItem, Select, FormControl, FormHelperText, InputLabel } from '@mui/material';
import { useFormikContext } from 'formik';
import SexInitValue from '../../../../../types/initValues/Sex.init';
import { AgentInputType } from '../../../../../types/AgentInputType.types';
import DebounceTextField from '../../../../../components/DebounceTextfield';
import { AgentStatus } from '../../../../../types/Agent.types';
import Agentv2 from '../../../../../types/Agentv2.types';
import ABWEICHENDER_VERTRAGSINHABER_HELPER_TEXT from '../../../../../constants/agentFieldHelperTexts';

function PersonalFields() {
  const { values, handleChange, errors, handleBlur, initialValues } = useFormikContext<AgentInputType | Agentv2>();

  const isDisabled = initialValues.status_id === AgentStatus.dismissed || values.status_id === AgentStatus.failed;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <DebounceTextField
          data-testid="agent-personaldata-name"
          type="text"
          label="Vorname"
          aria-label="name"
          name="name"
          value={values.name}
          onChange={handleChange}
          onBlur={handleBlur}
          helperText={errors.name}
          error={Boolean(errors.name) || false}
          fullWidth
          disabled={isDisabled}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <DebounceTextField
          data-testid="agent-personaldata-surname"
          label="Nachname"
          name="surname"
          aria-label="surname"
          value={values.surname}
          onChange={handleChange}
          onBlur={handleBlur}
          helperText={errors.surname}
          error={Boolean(errors.surname) || false}
          fullWidth
          disabled={isDisabled}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <DebounceTextField
          type="date"
          label="Geburtstag"
          name="birthday"
          value={values.birthday}
          onChange={handleChange}
          onBlur={handleBlur}
          helperText={errors.birthday}
          error={Boolean(errors.birthday) || false}
          disabled={isDisabled}
          fullWidth
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth error={Boolean(errors.is_male) || false} disabled={isDisabled}>
          <InputLabel>Geschlecht</InputLabel>
          <Select
            name="is_male"
            value={values.is_male}
            onChange={handleChange}
            label="Geschlecht"
            data-testid="is_male-select"
          >
            {SexInitValue.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.title}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>{errors.is_male}</FormHelperText>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <DebounceTextField
          label="Abweichender Vertragsinhaber"
          name="business_owner"
          value={values.business_owner || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          helperText={errors.business_owner || ABWEICHENDER_VERTRAGSINHABER_HELPER_TEXT}
          error={Boolean(errors.business_owner)}
          fullWidth
          disabled={isDisabled}
          placeholder="Optional"
        />
      </Grid>
    </Grid>
  );
}

export default PersonalFields;
